import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { CornBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { getMatch2AssetPath } from '../../util/assets';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/popcorn'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class CornBlockView extends Container {
  private movieclip: MovieClip;

  constructor(props: CornBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.movieclip.play('popcorn_state01', null, true);
  }

  public static assets() {
    return Object.values(manifest());
  }
}
